import { useEffect, useState } from "react";
import { FiMenu, FiSearch, FiBell, FiFilter, FiX, FiClock, FiChevronDown } from "react-icons/fi";
import UserProfile from "./userProfile";
import { getAccountData } from "@/context/getAccountData";

export default function Header({
  sidebarOpen,
  setSidebarOpen,
  showNotifications,
  toggleNotifications,
  showFilters,
  toggleFilters,
  showUserProfile,
  toggleUserProfile
}) {

  const [accountData, setAccountData] = useState(null);

  useEffect(() => {

    async function fetchData() {
      try {

        const data = await getAccountData();
        setAccountData(data);
      } catch (error) {
        console.error("Error al obtener los datos de la cuenta:", error);
      }
    }
    fetchData();
  }, []);

  return (
    <header className="bg-white shadow-sm z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="text-navy-900 md:hidden"
            >
              {sidebarOpen ? <FiX className="h-6 w-6" /> : <FiMenu className="h-6 w-6" />}
            </button>
            <div className="ml-4">
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="w-full md:w-64 pl-10 pr-4 py-2 rounded-md bg-gray-100 text-gray-700 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                </div>
                {/* Filter button */}
                <div className="relative">
                  <button
                    className="ml-2 p-2 bg-gray-100 text-gray-700 rounded-md border border-gray-300 hover:bg-gray-200"
                    onClick={toggleFilters}
                  >
                    <FiFilter className="h-5 w-5" />
                  </button>

                  {/* Filters dropdown */}
                  {showFilters && (
                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg overflow-hidden z-20">
                      <div className="p-4">
                        <h3 className="text-sm font-medium text-gray-900 mb-3">Filtros</h3>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Por fecha</label>
                            <div className="mt-1 flex space-x-2">
                              <input
                                type="date"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm"
                              />
                            </div>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Estado</label>
                            <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 rounded-md shadow-sm">
                              <option>Todos</option>
                              <option>En proceso</option>
                              <option>Completados</option>
                              <option>Cancelados</option>
                            </select>
                          </div>
                          <div>
                            <button className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
                              Aplicar filtros
                            </button>
                          </div>

                          <div className="border-t pt-2">
                            <button className="flex items-center text-gray-600 text-sm">
                              <FiClock className="h-4 w-4 mr-1" />
                              Mostrar recientes primero
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="relative">
              <button
                className="p-2 text-navy-600 hover:bg-gray-100 rounded-full relative"
                onClick={toggleNotifications}
              >
                <FiBell className="h-5 w-5" />
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"></span>
              </button>

              {/* Notifications dropdown */}
              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg overflow-hidden z-20">
                  <div className="p-2">
                    <h3 className="text-sm font-medium text-gray-900 p-2 border-b">Notificaciones</h3>
                    <div className="max-h-96 overflow-y-auto">
                      {/* Notification items */}
                      {[
                        { title: "Nuevo caso asignado", time: "Hace 10 minutos", read: false },
                        { title: "Reunión programada", time: "Hace 1 hora", read: false },
                        { title: "Documento actualizado", time: "Hace 3 horas", read: true },
                        { title: "Comentario nuevo en caso #532", time: "Ayer", read: true },
                        { title: "Recordatorio: Fecha límite", time: "Ayer", read: true }
                      ].map((notification, index) => (
                        <div
                          key={index}
                          className={`p-3 border-b hover:bg-gray-50 cursor-pointer ${notification.read ? 'bg-white' : 'bg-blue-50'}`}
                        >
                          <p className="text-sm font-medium text-gray-900">{notification.title}</p>
                          <p className="text-xs text-gray-500 mt-1">{notification.time}</p>
                        </div>
                      ))}
                    </div>
                    <div className="p-2 text-center border-t">
                      <a href="#" className="text-sm text-blue-600 hover:text-blue-800">Ver todas las notificaciones</a>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="ml-3 relative">
              <button
                className="flex items-center focus:outline-none"
                onClick={toggleUserProfile}
              >
                <img className="h-8 w-8 rounded-full" src={accountData?.imageUrl} alt="User avatar" />
                <span className="ml-2 text-sm font-medium text-navy-900">
                  {accountData?.username?.split(" ")[0]}
                </span>

                <FiChevronDown className="ml-1 h-4 w-4 text-navy-600" />
              </button>

              {/* User Profile Modal */}
              {showUserProfile && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg overflow-hidden z-20">
                  <div className="p-2">
                    <UserProfile
                      email={accountData?.email}
                      name={accountData?.username}
                      image={accountData?.imageUrl}
                      userType="Premium User"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}